import { put, call } from 'redux-saga/effects';
import { getHistoryConstantSuccessAction, getHistoryConstantFailureAction, createConstantSuccessAction, createConstantFailureAction } from '../actions/constantActions'
import { END_POINTS } from '../../api/endpoints';
import { API } from '../../api/api';

export function* getHistoryConfigs() {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const constantResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.historyConfig}`,
        );
        const citiesResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getCities}`,
        );
        if (constantResponse.success&&citiesResponse.success) {
            yield put(getHistoryConstantSuccessAction(constantResponse.data, citiesResponse.data));
        }
        else {
            throw new Error(constantResponse.message)
        }
    } catch (error) {
        yield put(getHistoryConstantFailureAction(error.message));
    }
}

export function* createConstant(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        let constantResponse = {}
        if (action.payload.label == "allergyId") {
            constantResponse = yield call(
                API.post,
                `${baseUrl}${END_POINTS.createAllergy}`,
                {
                    name: action.payload.name
                }
            );
        }
        else {
            constantResponse = yield call(
                API.post,
                `${baseUrl}${END_POINTS.createData}`,
                {
                    name: action.payload.name
                }
            );
        }

        if (constantResponse.success) {
            yield put(createConstantSuccessAction(constantResponse.data,action.payload.label));
        }
        else {
            throw new Error(constantResponse.message)
        }
    } catch (error) {
        yield put(createConstantFailureAction(error.message));
    }
}

